$(function(){
	if($('#header-nav').length){
		$(window).resize(function(){
			body.removeClass('header-collapse');
			if($('#header-logo').offset().top != $('#header-nav').offset().top){
				body.addClass('header-collapse');
			}
		}).resize();
		$(window).bind('load',function(){
			$(window).resize();
		});
	}
});